<div class="main-scrolling-area simple-scroll" data-cy="qnr-container">
    <div *ngIf="sections.length > 0" class="fixed-width-area flex flex-col" data-cy="qnr-content">
        <header data-cy="qnr-header">
            <div class="contents">
                <h1 data-cy="qnr-title">{{selectedTab?.name}}</h1>
                <!--<p>File description can be displayed here.</p>-->
            </div>
            <div class="buttons-container" data-cy="qnr-actions">
                <button mat-button feature="outlined"
                        data-cy="qnr-add-section"
                        *ngIf="!singleSectionOnly && flowChartDataService.hasAddSectionPermission(flowchart)"
                        (click)="addSection();">
                    <i class="fa-regular fa-plus"></i>
                    Add Section
                </button>
            </div>
        </header>
        <div class="root-container w-p-100 flex flex-row justify-start items-start full-grow-no-shrink-no-basis" data-cy="qnr-sections-container">

            <mat-accordion class="full-grow-no-shrink-no-basis" data-cy="qnr-sections-accordion">

                <!-- #enddocregion basic-panel -->
                <mat-expansion-panel *ngFor="let section of sections; let i = index;"
                                     [attr.data-cy]="'qnr-section-' + section?.title"
                                     (opened)="section.panelOpenState = true"
                                     (closed)="section.panelOpenState = false"
                                     [expanded]="defaultExpansionPanelIndex==i ? true : section.panelOpenState">
                    <mat-expansion-panel-header [attr.data-cy]="'qnr-section-header-' + section?.title">
                        <mat-panel-title>
                            <div style="overflow: hidden;
    white-space: nowrap;
    width: 0;
    flex-grow: 1;
    text-overflow: ellipsis;" matTooltip="{{section?.title}}"
                                 [attr.data-cy]="'qnr-section-title-' + section?.title">{{section?.title}}</div>
                            <div>
                                <button *ngIf="section.panelOpenState === true &&
                            (flowChartDataService.hasUpdateSectionPermission(flowchart) ||
                            flowChartDataService.hasDeleteSectionPermission(flowchart) ||
                            hasAddFieldPermission)"
                                        mat-icon-button
                                        [attr.data-cy]="'qnr-section-actions-' + section?.title"
                                        [matMenuTriggerFor]="actionMenu"
                                        (click)="$event.stopPropagation()">
                                    <mat-icon class="s-20">more_horiz</mat-icon>
                                </button>
                                <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container"
                                          [overlapTrigger]="false"
                                          [attr.data-cy]="'qnr-section-menu-' + section?.title">
                                    <button mat-menu-item class="" *ngIf="hasAddFieldPermission"
                                            [attr.data-cy]="'qnr-add-field-' + section?.title"
                                            (click)="onActionClicked('add-field')">
                                        <span>Add Field</span>
                                    </button>
                                    <button *ngIf="menuConfig && menuConfig.addSnippet && menuConfig.addSnippet.isVisible"
                                            mat-menu-item
                                            class=""
                                            [attr.data-cy]="'qnr-add-snippet-' + section?.title"
                                            (click)="onActionClicked('add-snippet')">
                                        <span>{{menuConfig.addSnippet.displayText}}</span>
                                    </button>
                                    <button mat-menu-item class=""
                                            *ngIf="flowChartDataService.hasUpdateSectionPermission(flowchart)"
                                            [attr.data-cy]="'qnr-edit-section-' + section?.title"
                                            (click)="onActionClicked('edit-section')">
                                        <span>Edit Section</span>
                                    </button>
                                    <button mat-menu-item class=""
                                            *ngIf="flowChartDataService.hasDeleteSectionPermission(flowchart)"
                                            [attr.data-cy]="'qnr-delete-section-' + section?.title"
                                            (click)="onActionClicked('delete-section')">
                                        <span>Delete Section</span>
                                    </button>


                                </mat-menu>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <particle-platform-tool-questionnaire *ngIf="section.panelOpenState && flowchart"
                                                          [attr.data-cy]="'qnr-section-content-' + section?.title"
                                                          [section]="section"
                                                          [sourceType]="selectedTab.tabData['SourceType']"
                                                          [flowChartDataService]="flowChartDataService"
                                                          [flowChartId]="selectedTab.tabData['FlowChartId']"
                                                          [flowchart]="flowchart"
                                                          [selectedTab]="selectedTab"
                                                          [menuConfig]="menuConfig"
                                                          [actionEvents]="actionEvents">
                    </particle-platform-tool-questionnaire>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>
